module.exports = __webpack_public_path__ + "img/18410271000342.e49492fa.png";